/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum ERROR_CODES {
  userNotFound = 1001,
  companyNotFound = 1004,
  companyIsInDeletedState = 2002,
  passwordExpired = 2019,
  userAccountLocked = 2021,
  emailIsNotConfirmed = 4002,
  userIsInPendingState = 4003,
  companyIsInPausedState = 4004,
  companyIsInPreRegisteredState = 5039,
  paymetricServiceUnavailable = 5063,
  companyIsInSuspendedState = 5094,
  userAlreadyExist = 'user_already_exists',
  invalid_credentials = 'invalid_credentials',
  addressIsNotValid = 'addressIsNotValid',
  linkInvalid = 'tokenInvalid',
  linkExpired = 'tokenExpired',
  passwordUsedBefore = 'passwordUsedBefore',
  linkUsed = 'tokenAlreadyUsed',
  userAlreadyActivated = 'user_already_activated',
  changeEmailLinkAlreadyUsed = 'user_email_update_not_found',
  subscriptionNoAvailableDevice = 'subscription_no_available_device',
  subscriptionPlanHasNoAvailableDevice = 'subscription_plan_has_no_available_devices',
  paymentricInvalidAccountNumber = 'paymetric_invalid_account_number',
  paymetricAuthorizationFailed = 'paymetric_authorization_failed',
  sabrixNotAvailable = 'sabrix_not_available',
  userEmailNotConfirmed = 'user_email_not_confirmed',
  paymetricCardCheckFailed = 'paymetric_card_check_failed'
}
